// THIS FILE IS AUTOMATICALLY GENERATED IN:
//
//   build-utils/update-file-index.js
//
// YOU SHOULD NEVER UPDATE THIS FILE DIRECTLY

import PuiButton from './PuiButton.vue'
import PuiIcon from './PuiIcon.vue'
import PuiNextPrev from './PuiNextPrev.vue'

// Export components individually
export { PuiButton, PuiIcon, PuiNextPrev }

// What should happen if the user installs the library as a plugin
function install(Vue) {
  Vue.component('PuiButton', PuiButton)
  Vue.component('PuiIcon', PuiIcon)
  Vue.component('PuiNextPrev', PuiNextPrev)
}

// Export the library as a plugin
export default { install: install }
